<template>
  <div>
    <van-empty
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="敬请期待！！！"
    />
  </div>
</template>
<script>
export default {
  data(){
    return{
      
    }
  }
}
</script>
<style scoped>
.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
</style>